import axios from "axios";
import { setAlert } from "./alert";

import {
  ADD_GRADE,
  ADD_GRADE_ERROR,
  GET_GRADE_LIST,
  GET_GRADE_LIST_ERROR,
  GET_GRADE,
  GET_GRADE_ERROR,
  DELETE_GRADE,
  DELETE_GRADE_ERROR,
  GET_GRADE_PAGE_ERROR,
  GET_GRADE_PAGE,
} from "./types";

// Get all enquiries
export const getUsers = () => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + "/v2/subadmin"
    );

    dispatch({
      type: GET_GRADE_LIST,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_GRADE_LIST_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get enquiry by ID
export const getCurrentGrade = (gradeId) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/subadmin/${gradeId}`
    );

    dispatch({
      type: GET_GRADE,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_GRADE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get enquiry by ID
export const updateSubAdminPassword = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + `/v2/subadmin/updatePassword`,
      formData,
      config
    );

    dispatch({
      type: ADD_GRADE,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: ADD_GRADE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
// Get enquiry with pages
export const login = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/subadmin/login`,
      formData,
      config
    );

    dispatch({
      type: ADD_GRADE,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: ADD_GRADE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Create enquiry
export const addSubAdmin = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + "/v2/subadmin/register",
      formData,
      config
    );

    dispatch({
      type: ADD_GRADE,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_GRADE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

// Delete enquiry
export const deleteUser = (gradeId) => async (dispatch) => {
  try {
    const res = await axios.delete(
      process.env.REACT_APP_SITE_URL + `/v2/subadmin/${gradeId}`
    );
    dispatch({
      type: DELETE_GRADE,
      payload: res.data,
    });

    dispatch(setAlert("Record has been removed", "success"));
  } catch (err) {
    dispatch({
      type: DELETE_GRADE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
